export enum LeakScoreMode {
  Legacy = 'LEGACY',
  AiPredictor = 'AIPREDICTOR',
}
